"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCombienTempsRealisezInvestissements = void 0;
exports.ESubCombienTempsRealisezInvestissements = {
    less_5_ans: "less_5_ans",
    between_5_10_ans: "between_5_10_ans",
    between_10_15_ans: "between_10_15_ans",
    greater_15_ans: "greater_15_ans",
};
